import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private snackBar: MatSnackBar) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.authService.logout();
          this.snackBar.open('Session expired. Please log in again.', 'Close', { duration: 4000 });
        } else if (error.status === 403) {
          this.snackBar.open('You do not have permission to perform this action.', 'Close', { duration: 4000 });
        } else if (error.status === 0) {
          this.snackBar.open('Cannot connect to server. Please check your connection.', 'Close', { duration: 5000 });
        } else {
          const msg = error.error?.message?.[0] || error.error?.message || error.message || 'An error occurred';
          this.snackBar.open(Array.isArray(msg) ? msg[0] : msg, 'Close', { duration: 4000 });
        }
        return throwError(() => error);
      }),
    );
  }
}
